import firebase from "../../config/firebase";
import algoliasearch from "algoliasearch";
import { toast } from "react-toastify";
import { createNullCache } from "@algolia/cache-common";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});
export const getAllAdmins =
  (search, hitsPerPage, currentPage) => async (dispatch) => {
    dispatch(AdminLoader(true));
    const index = client.initIndex("users");
    index
      .search(search, {
        filters: "type:admin",
        hitsPerPage: hitsPerPage,
        page: currentPage,
      })
      .then((response) => {
        let { hits, ...rest } = response;
        dispatch({
          type: "GET_ALL_ADMINS",
          payload: hits,
        });

        dispatch({ type: "ADMINS_DETAILS", payload: rest });
        dispatch(AdminLoader(false));
      });
  };

export const updateSubAdmin = (id, obj, onSuccess) => async (dispatch) => {
  dispatch(updateAdminLoader(id));
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .update(obj)
    .then(() => {
      dispatch(updateAdminLoader(""));
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      console.error(err.message);
      dispatch(updateAdminLoader(""));
    });
};

export const deleteSubAdmin = (id, onSuccess) => async (dispatch) => {
  dispatch(deleteAdminLoader(id));
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .delete()
    .then(() => {
      dispatch(deleteAdminLoader(""));
      toast.success("Data deleted Successfully..");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      console.error(err.message);
      dispatch(deleteAdminLoader(""));
    });
};

const AdminLoader = (data) => async (dispatch) => {
  dispatch({
    type: "ADMIN_LOADER",
    payload: data,
  });
};

const updateAdminLoader = (data) => async (dispatch) => {
  dispatch({
    type: "UPDATE_ADMIN_LOADER",
    payload: data,
  });
};

const deleteAdminLoader = (data) => async (dispatch) => {
  dispatch({
    type: "DELETE_ADMIN_LOADER",
    payload: data,
  });
};
